import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AuthLayout from "../components/common/AuthLayout";

function getError(error) {
  if (!error.response)
    return error.message === "Network Error"
      ? "Unable to reach the API. Check that the backend is running on localhost:5000, then restart React. Check Network for the request URL."
      : error.message || "Unable to connect.";
  const data = error.response.data;
  return (
    data?.message || data?.error || "Registration failed. Please try again."
  );
}
export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    username: "",
    mobile: "",
    password: "",
    confirmPassword: "",
  });
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const change = (key) => (e) =>
    setForm((prev) => ({ ...prev, [key]: e.target.value }));

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    if (!form.username.trim()) return setError("Enter your username.");
    if (!/^\d{10}$/.test(form.mobile.trim()))
      return setError("Enter a valid 10-digit mobile number.");
    if (form.password.length < 6)
      return setError("Password must be at least 6 characters.");
    if (form.password !== form.confirmPassword)
      return setError("Passwords do not match.");
    setLoading(true);
    try {
      await register(form);
      navigate("/login", { replace: true, state: { registered: true } });
    } catch (err) {
      setError(getError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      eyebrow="JOIN THE TABLE"
      title="Create your account"
      subtitle="Set up your profile and start your experience."
    >
      {error && (
        <div className="auth-alert error" role="alert">
          {error}
        </div>
      )}
      <form onSubmit={onSubmit} className="auth-form">
        <label htmlFor="register-username">Username</label>
        <div className="auth-input-wrap">
          <span className="field-icon">◎</span>
          <input
            id="register-username"
            autoComplete="username"
            maxLength={40}
            placeholder="Choose a username"
            value={form.username}
            onChange={change("username")}
            required
          />
        </div>
        <label htmlFor="register-mobile">Mobile number</label>
        <div className="auth-input-wrap">
          <span className="field-icon">✆</span>
          <input
            id="register-mobile"
            type="tel"
            inputMode="numeric"
            autoComplete="tel-national"
            maxLength={10}
            placeholder="10-digit mobile number"
            value={form.mobile}
            onChange={change("mobile")}
            required
          />
        </div>
        <label htmlFor="register-password">Password</label>
        <div className="auth-input-wrap">
          <span className="field-icon">♢</span>
          <input
            id="register-password"
            type={visible ? "text" : "password"}
            autoComplete="new-password"
            minLength={6}
            placeholder="Minimum 6 characters"
            value={form.password}
            onChange={change("password")}
            required
          />
          <button
            type="button"
            className="show-password"
            onClick={() => setVisible((x) => !x)}
          >
            {visible ? "Hide" : "Show"}
          </button>
        </div>
        <label htmlFor="register-confirm">Confirm password</label>
        <div className="auth-input-wrap">
          <span className="field-icon">♢</span>
          <input
            id="register-confirm"
            type={visible ? "text" : "password"}
            autoComplete="new-password"
            placeholder="Re-enter password"
            value={form.confirmPassword}
            onChange={change("confirmPassword")}
            required
          />
        </div>
        <button className="auth-submit" type="submit" disabled={loading}>
          {loading ? "Creating account…" : "Create account"}{" "}
          <span aria-hidden="true">→</span>
        </button>
      </form>
      <p className="auth-switch">
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </AuthLayout>
  );
}
